import {useLocation, useNavigate, useParams} from "react-router";
import {useCampaign} from "@/campaigns/CampaignContextHooks.ts";
import DetailPaneState from "@/components/management/DetailPaneState.tsx";
import {useModal} from "@/modal/ModalHooks.ts";
import SpellDetail from "@/spells/SpellDetail.tsx";
import {useDeleteSpellMutation, useSpellQuery} from "@/spells/SpellQueries.ts";

export default function SpellDetailRoute() {
    const {id} = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const {campaignPath} = useCampaign();
    const {showSpell} = useModal();
    const query = useSpellQuery(id);
    const deleteMutation = useDeleteSpellMutation();

    if (query.isPending) return <DetailPaneState title="Zauber wird geladen…" loading/>;
    if (query.isError) return <DetailPaneState title="Zauber konnte nicht geladen werden" onRetry={() => void query.refetch()}/>;
    if (!query.data) return <DetailPaneState title="Zauber nicht verfügbar"/>;

    const spell = query.data;
    const edit = () => navigate({pathname: campaignPath(`spells/${spell.id}/edit`), search: location.search});
    const remove = async () => {
        await deleteMutation.mutateAsync(spell.id);
        navigate({pathname: campaignPath("spells"), search: location.search}, {replace: true});
    };

    return <SpellDetail spell={spell}
                        onDisplay={() => showSpell(spell.id)}
                        onEdit={edit}
                        onDelete={remove}/>;
}
